import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { APP_LOGO } from "@/lib/constants";
import { CheckCircle2 } from "lucide-react";

export default function Register() {
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    setError("");
    if (!f.name || !f.email || f.password.length < 6) { setError("Lengkapi nama, email, dan password (min. 6 karakter)"); return; }
    setLoading(true);
    try { await api.post("/auth/register-client", f); setDone(true); }
    catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex justify-center mb-8"><img src={APP_LOGO} alt="Primrose" className="h-28 w-auto object-contain" /></div>
        {done ? (
          <div className="card-lux p-6 text-center">
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3" strokeWidth={1.4} />
            <h3 className="font-heading text-2xl text-burgundy mb-1">Registrasi Terkirim</h3>
            <p className="text-sm text-[#7A7A7A]">Akun Anda menunggu persetujuan admin. Anda akan bisa login setelah disetujui.</p>
            <Link to="/login" className="inline-block mt-5 text-sm text-burgundy underline" data-testid="to-login">Kembali ke login</Link>
          </div>
        ) : (
          <div className="card-lux p-6">
            <h3 className="font-heading text-2xl text-[#1A1A1A] mb-1">Daftar Akun Client</h3>
            <p className="text-sm text-[#7A7A7A] mb-5">Buat akun untuk memantau persiapan acara Anda.</p>
            <div className="space-y-3">
              <div><Label className="text-xs font-semibold mb-1 block">Nama</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="reg-name" className="bg-white" /></div>
              <div><Label className="text-xs font-semibold mb-1 block">Email</Label><Input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="reg-email" className="bg-white" /></div>
              <div><Label className="text-xs font-semibold mb-1 block">Password</Label><Input type="password" value={f.password} onChange={(e) => set("password", e.target.value)} data-testid="reg-password" className="bg-white" /></div>
              <div><Label className="text-xs font-semibold mb-1 block">No. WhatsApp</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} data-testid="reg-phone" className="bg-white" /></div>
            </div>
            {error && <p className="text-sm text-red-600 mt-3">{error}</p>}
            <Button onClick={submit} disabled={loading} data-testid="reg-submit" className="w-full mt-4 bg-burgundy hover:bg-burgundy-dark text-white rounded-full py-6">{loading ? "Memproses..." : "Daftar"}</Button>
            <Link to="/login" className="block text-center mt-4 text-sm text-[#7A7A7A] hover:text-burgundy">Sudah punya akun? Login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
